import { render, staticRenderFns } from "./ToolbarGroup.vue?vue&type=template&id=442c8136"
import script from "./ToolbarGroup.vue?vue&type=script&lang=js"
export * from "./ToolbarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports